import { render } from "./LeafPage.vue?vue&type=template&id=2c469e52"
import script from "./LeafPage.vue?vue&type=script&lang=js"
export * from "./LeafPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__